import { getPathToPageIdMap } from '@move-frontend/contentful-routes';
import { contentful } from '../../../../shared/api/contentful';
import { ILocale } from '../../../../shared/i18n/locale/models/ILocale';
import { customPagePathToPageIdMap } from '../constants/customPagePathToPageIdMap';

export function getLocalizedPathToPageIdMap(locale: ILocale) {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	return getPathToPageIdMap(contentful(), locale, customPagePathToPageIdMap);
}
